module.exports = __webpack_public_path__ + "img/novipro.58c639c9.png";